class CommonData {
    static data = {
      fundCode: '000001',
      fundType: 'F_H_--',
      chartType: '',
      fundData: {},
      stokeData: {},
    }
}
export default CommonData.data;
